class DualRangeSlider {
  constructor(element) {
    this.element = element;
    this.container = element.querySelector('.dual-range-slider__container');
    this.track = element.querySelector('.dual-range-slider__track');
    this.range = element.querySelector('.dual-range-slider__range');
    this.minThumb = element.querySelector('.dual-range-slider__thumb--min');
    this.maxThumb = element.querySelector('.dual-range-slider__thumb--max');
    this.minValueDisplay = element.querySelector('.dual-range-slider__value--min');
    this.maxValueDisplay = element.querySelector('.dual-range-slider__value--max');
    
    // データ属性から設定を取得
    this.min = parseFloat(element.dataset.min);
    this.max = parseFloat(element.dataset.max);
    this.step = parseFloat(element.dataset.step) || 1;
    this.currency = element.dataset.currency || '¥';
    this.minInputId = element.dataset.minInput;
    this.maxInputId = element.dataset.maxInput;
    
    // 現在の値（整数に丸める）
    this.minValue = Math.round(parseFloat(element.dataset.currentMin) || this.min);
    this.maxValue = Math.round(parseFloat(element.dataset.currentMax) || this.max);
    
    // Shopifyの入力フィールド
    this.minInput = document.getElementById(this.minInputId);
    this.maxInput = document.getElementById(this.maxInputId);
    
    // 状態管理
    this.isDragging = false;
    this.activeThumb = null;
    
    this.init();
  }
  
  init() {
    this.updateSliderPosition();
    this.updateDisplay();
    this.bindEvents();
  }
  
  bindEvents() {
    // マウスイベント
    this.minThumb.addEventListener('mousedown', (e) => this.startDrag(e, 'min'));
    this.maxThumb.addEventListener('mousedown', (e) => this.startDrag(e, 'max'));
    
    // タッチイベント（モバイル対応）
    this.minThumb.addEventListener('touchstart', (e) => this.startDrag(e, 'min'), { passive: false });
    this.maxThumb.addEventListener('touchstart', (e) => this.startDrag(e, 'max'), { passive: false });
    
    // グローバルイベント
    document.addEventListener('mousemove', (e) => this.onDrag(e));
    document.addEventListener('mouseup', () => this.stopDrag());
    document.addEventListener('touchmove', (e) => this.onDrag(e), { passive: false });
    document.addEventListener('touchend', () => this.stopDrag());
    
    // トラッククリック
    this.track.addEventListener('click', (e) => this.onTrackClick(e));
    
    // キーボードサポート
    this.minThumb.addEventListener('keydown', (e) => this.onKeyDown(e, 'min'));
    this.maxThumb.addEventListener('keydown', (e) => this.onKeyDown(e, 'max'));
    
    // フォーカス可能にする
    this.minThumb.setAttribute('tabindex', '0');
    this.maxThumb.setAttribute('tabindex', '0');
  }
  
  startDrag(e, thumb) {
    e.preventDefault();
    this.isDragging = true;
    this.activeThumb = thumb;
    
    // ドラッグ中のクラスを追加
    const thumbElement = thumb === 'min' ? this.minThumb : this.maxThumb;
    thumbElement.classList.add('dragging');
    this.range.classList.add('updating');
    this.minValueDisplay.classList.add('updating');
    this.maxValueDisplay.classList.add('updating');
    
    // アクティブなサムのz-indexを上げる
    if (thumb === 'min') {
      this.minThumb.style.zIndex = '3';
      this.maxThumb.style.zIndex = '1';
    } else {
      this.maxThumb.style.zIndex = '3';
      this.minThumb.style.zIndex = '1';
    }
    
    // カーソルスタイルを変更
    document.body.style.cursor = 'grabbing';
    document.body.style.userSelect = 'none';
  }
  
  onDrag(e) {
    if (!this.isDragging || !this.activeThumb) return;
    
    e.preventDefault();
    
    const rect = this.track.getBoundingClientRect();
    const clientX = e.type.includes('touch') ? e.touches[0].clientX : e.clientX;
    const percent = Math.max(0, Math.min(1, (clientX - rect.left) / rect.width));
    const value = this.min + percent * (this.max - this.min);
    const steppedValue = Math.round(Math.round(value / this.step) * this.step);
    
    if (this.activeThumb === 'min') {
      this.minValue = Math.min(steppedValue, this.maxValue);
    } else {
      this.maxValue = Math.max(steppedValue, this.minValue);
    }
    
    // スロットリング処理で滑らかな更新
    if (!this.animationFrame) {
      this.animationFrame = requestAnimationFrame(() => {
        this.updateSliderPosition();
        this.updateDisplay();
        this.animationFrame = null;
      });
    }
  }
  
  stopDrag() {
    if (this.isDragging) {
      this.isDragging = false;
      const activeThumbElement = this.activeThumb === 'min' ? this.minThumb : this.maxThumb;
      this.activeThumb = null;
      
      // ドラッグ中のクラスを削除
      activeThumbElement.classList.remove('dragging');
      this.range.classList.remove('updating');
      this.minValueDisplay.classList.remove('updating');
      this.maxValueDisplay.classList.remove('updating');
      
      // z-indexをリセット
      this.minThumb.style.zIndex = '1';
      this.maxThumb.style.zIndex = '1';
      
      // カーソルスタイルをリセット
      document.body.style.cursor = '';
      document.body.style.userSelect = '';
      
      // Shopifyの入力フィールドを更新
      this.updateShopifyInputs();
    }
  }
  
  onTrackClick(e) {
    if (this.isDragging) return;
    
    const rect = this.track.getBoundingClientRect();
    const percent = (e.clientX - rect.left) / rect.width;
    const value = this.min + percent * (this.max - this.min);
    const steppedValue = Math.round(Math.round(value / this.step) * this.step);
    
    // 近い方のサムを移動
    const distToMin = Math.abs(steppedValue - this.minValue);
    const distToMax = Math.abs(steppedValue - this.maxValue);
    
    if (distToMin < distToMax) {
      this.minValue = Math.min(steppedValue, this.maxValue);
    } else {
      this.maxValue = Math.max(steppedValue, this.minValue);
    }
    
    this.updateSliderPosition();
    this.updateDisplay();
    this.updateShopifyInputs();
  }
  
  onKeyDown(e, thumb) {
    let change = 0;
    
    switch (e.key) {
      case 'ArrowLeft':
      case 'ArrowDown':
        change = -this.step;
        break;
      case 'ArrowRight':
      case 'ArrowUp':
        change = this.step;
        break;
      case 'Home':
        if (thumb === 'min') {
          this.minValue = this.min;
        } else {
          this.maxValue = this.max;
        }
        break;
      case 'End':
        if (thumb === 'min') {
          this.minValue = this.maxValue;
        } else {
          this.maxValue = this.max;
        }
        break;
      default:
        return;
    }
    
    e.preventDefault();
    
    if (change !== 0) {
      if (thumb === 'min') {
        this.minValue = Math.round(Math.max(this.min, Math.min(this.maxValue, this.minValue + change)));
      } else {
        this.maxValue = Math.round(Math.min(this.max, Math.max(this.minValue, this.maxValue + change)));
      }
    }
    
    this.updateSliderPosition();
    this.updateDisplay();
    this.updateShopifyInputs();
  }
  
  updateSliderPosition() {
    const minPercent = (this.minValue - this.min) / (this.max - this.min) * 100;
    const maxPercent = (this.maxValue - this.min) / (this.max - this.min) * 100;
    
    // requestAnimationFrameを使用して滑らかな更新
    requestAnimationFrame(() => {
      this.minThumb.style.left = minPercent + '%';
      this.maxThumb.style.left = maxPercent + '%';
      
      this.range.style.left = minPercent + '%';
      this.range.style.width = (maxPercent - minPercent) + '%';
    });
  }
  
  updateDisplay() {
    this.minValueDisplay.textContent = this.formatPrice(this.minValue);
    this.maxValueDisplay.textContent = this.formatPrice(this.maxValue);
  }
  
  formatPrice(value) {
    const intValue = Math.round(value);
    return this.currency + new Intl.NumberFormat('ja-JP').format(intValue);
  }
  
  updateShopifyInputs() {
    // デバウンス処理
    if (this.updateTimer) {
      clearTimeout(this.updateTimer);
    }
    
    this.updateTimer = setTimeout(() => {
      if (this.minInput && this.maxInput) {
        const roundedMinValue = Math.round(this.minValue);
        const roundedMaxValue = Math.round(this.maxValue);
        
        if (roundedMinValue > this.min) {
          this.minInput.value = new Intl.NumberFormat('ja-JP').format(roundedMinValue);
        } else {
          this.minInput.value = '';
        }
        
        if (roundedMaxValue < this.max) {
          this.maxInput.value = new Intl.NumberFormat('ja-JP').format(roundedMaxValue);
        } else {
          this.maxInput.value = '';
        }
        
        // price-rangeカスタム要素を探してイベントをトリガー
        const priceRangeElement = this.element.closest('price-range');
        if (priceRangeElement) {
          this.minInput.dispatchEvent(new Event('input', { bubbles: true }));
          this.maxInput.dispatchEvent(new Event('input', { bubbles: true }));
          
          setTimeout(() => {
            this.minInput.dispatchEvent(new Event('change', { bubbles: true }));
            this.maxInput.dispatchEvent(new Event('change', { bubbles: true }));
            
            if (priceRangeElement.onRangeChange) {
              priceRangeElement.onRangeChange();
            }
            
            const form = this.minInput.closest('form');
            if (form) {
              const formData = new FormData(form);
              const event = new CustomEvent('facet:changed', { 
                detail: { formData },
                bubbles: true 
              });
              form.dispatchEvent(event);
            }
          }, 100);
        }
      }
    }, 300);
  }
}

// 初期化
document.addEventListener('DOMContentLoaded', function() {
  initializeDualRangeSliders();
});

function initializeDualRangeSliders() {
  const sliders = document.querySelectorAll('.dual-range-slider');
  sliders.forEach(slider => {
    if (!slider.dataset.initialized) {
      new DualRangeSlider(slider);
      slider.dataset.initialized = 'true';
    }
  });
}

// 動的コンテンツ対応
const observer = new MutationObserver(function(mutations) {
  let shouldInit = false;
  
  mutations.forEach(function(mutation) {
    mutation.addedNodes.forEach(function(node) {
      if (node.nodeType === 1 && (node.classList?.contains('dual-range-slider') || node.querySelector?.('.dual-range-slider'))) {
        shouldInit = true;
      }
    });
  });
  
  if (shouldInit) {
    setTimeout(initializeDualRangeSliders, 100);
  }
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});